import { Routes } from '@angular/router';
import { ErrorComponent } from 'src/app/shared/components/error/error.component';
import { AppLayoutComponent } from './shared/components/app-layout/app-layout.component';
import { Error404Component } from './shared/components/error404/error404.component';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import {
  ADDRESS_PATH,
  CEILING_REINFORCEMENT_PATH,
  COMPLEMENT_PATH,
  CONFIRMATION_PATH,
  CONTEXT_PATH,
  CONTRACT_VALIDATION_PATH,
  CROSS_SELLING_C_PATH,
  CROSS_SELLING_W_PATH,
  DEPTHS_PATH,
  DIRECT_DEBIT_PATH,
  DURABLE_DEVELOPMENT_PATH,
  E_SIGN_MSG_STATUS_PATH,
  ERROR_404_PATH,
  ERROR_EMAIL_PATH,
  HOUSING_RESIDENT_PATH,
  HOUSING_TENANT_PATH,
  HOUSING_TYPE_PATH,
  HOUSING_USE_PATH,
  INSURED_VALUE_PATH,
  INSURER_RESILIATION_PATH,
  LESSOR_NOTIFICATION_PATH,
  LESSOR_PATH,
  NUMBER_PIECES_PATH,
  OFFER_CUSTOMIZATION_PATH,
  OFFER_CUSTOMIZE_PATH,
  OPTIONS_PATH,
  PERSONALIZATION_PATH,
  PREFERENTIAL_RATE_PATH,
  PRODUCT_PATH,
  QUOTE_CONFIRMATION_PATH,
  REVENUS_PATH,
  ROOMMATES_INFO_PATH,
  ROOT_PATH,
  SCHOOL_INSURANCE_PATH,
  SIGNATURE_STATUS_PATH,
  SINISTER_HISTORY_PATH,
  SPECIAL_CONDITIONS_PATH,
  START_CONTEXT_PATH,
  START_CONTEXT_PRODUCT_PATH,
  STUDENT_AGE_PATH,
  SUBSCRIBER_PATH,
  SUBSCRIPTION_PATH,
  SURFACE_DEPENDANCES_PATH,
  SWIMMING_POOL_PATH,
} from './shared/constants/route.constants';
import { ContextGuard } from './shared/guards/context.guard';
import { DevGuard } from './shared/guards/dev.guard';
import { partnerGuard } from './shared/guards/partner.guard';
import { ProductGuard } from './shared/guards/product.guard';
import { RedirectGuard } from './shared/guards/redirect.guard';
import { StartGuard } from './shared/guards/start.guard';
import { StepActivationGuard } from './shared/guards/step-activation.guard';
import { contextDeclarationResolver } from './shared/resolvers/context-declaration.resolver';
import { SkeepersService } from './shared/services/skeepers.service';
import { ESignMsgComponent } from './views/process/options/e-sign-msg/e-sign-msg.component';
import { lessorResolver } from './views/process/options/lessor/lessor.resolver';
import { personnalizationPriceResolver } from './views/process/options/personnalization/personnalization.resolver';
import { revenusResolver } from './views/process/options/revenus/revenus.resolver';

export const route_mrh: Routes = [
  {
    path: ADDRESS_PATH,
    canActivate: [partnerGuard, StepActivationGuard],
    loadComponent: () => import('./views/process/options/address/address.component').then((m) => m.AddressComponent),
  },
  {
    path: COMPLEMENT_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/complements/complements.component').then((m) => m.ComplementsComponent),
  },
  {
    path: HOUSING_USE_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/housing-use/housing-use.component').then((m) => m.HousingUseComponent),
  },
  {
    path: HOUSING_TYPE_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/housing-type/housing-type.component').then((m) => m.HousingTypeComponent),
  },
  {
    path: HOUSING_TENANT_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/housing-tenant/housing-tenant.component').then((m) => m.qualiteOccupantComponent),
  },
  {
    path: PERSONALIZATION_PATH,
    canActivate: [StepActivationGuard],
    resolve: { prices: personnalizationPriceResolver },
    loadComponent: () =>
      import('./views/process/options/personnalization/personnalization.component').then(
        (m) => m.PersonnalizationComponent,
      ),
  },
  {
    path: HOUSING_RESIDENT_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/housing-residents/housing-residents.component').then(
        (m) => m.HousingResidentsComponent,
      ),
  },
  {
    path: SINISTER_HISTORY_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/sinister-history/sinister-history.component').then(
        (m) => m.SinisterHistoryComponent,
      ),
  },
  {
    path: SURFACE_DEPENDANCES_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/surface-dependances/surface-dependances.component').then(
        (m) => m.SurfaceDependancesComponent,
      ),
  },
  {
    path: REVENUS_PATH,
    canActivate: [StepActivationGuard],
    resolve: { bareme: revenusResolver },
    loadComponent: () => import('./views/process/options/revenus/revenus.component').then((m) => m.RevenusComponent),
  },
  {
    path: NUMBER_PIECES_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/number-pieces/number-pieces.component').then((m) => m.NumberPiecesComponent),
  },
  {
    path: ROOMMATES_INFO_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/roommates-informations/roommates-informations.component').then(
        (m) => m.RoommatesInformationsComponent,
      ),
  },
  {
    path: DEPTHS_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/dependances/dependances.component').then((m) => m.DependancesComponent),
  },
  {
    path: LESSOR_PATH,
    canActivate: [StepActivationGuard],
    resolve: { lessors: lessorResolver },
    loadComponent: () => import('./views/process/options/lessor/lessor.component').then((m) => m.LessorComponent),
  },
  {
    path: STUDENT_AGE_PATH,
    canActivate: [StepActivationGuard],
    loadComponent: () =>
      import('./views/process/options/student-age/student-age.component').then((m) => m.StudentAgeComponent),
  },
  {
    path: SUBSCRIBER_PATH,
    loadComponent: () =>
      import('./views/process/options/subscriber/subscriber.component').then((m) => m.SubscriberComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: PREFERENTIAL_RATE_PATH,
    loadComponent: () =>
      import('./views/process/options/preferential-rate/preferential-rate.component').then(
        (m) => m.PreferentialRateComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: DURABLE_DEVELOPMENT_PATH,
    loadComponent: () =>
      import('./views/process/options/durable-development/durable-development.component').then(
        (m) => m.DurableDevelopmentComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: OFFER_CUSTOMIZATION_PATH,
    loadComponent: () =>
      import('./views/process/options/offer-customization/offer-customization.component').then(
        (m) => m.OfferCustomizationComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: SWIMMING_POOL_PATH,
    loadComponent: () =>
      import('./views/process/options/swimming-pool/swimming-pool.component').then((m) => m.SwimmingPoolComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: INSURED_VALUE_PATH,
    loadComponent: () =>
      import('./views/process/options/insured-value/insured-value.component').then((m) => m.InsuredValueComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: OFFER_CUSTOMIZE_PATH,
    loadComponent: () =>
      import('./views/process/options/offer-customize/offer-customize.component').then(
        (m) => m.OfferCustomizeComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: QUOTE_CONFIRMATION_PATH,
    loadComponent: () =>
      import('./views/process/options/quote-confirmation/quote-confirmation.component').then(
        (m) => m.QuoteConfirmationComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: CEILING_REINFORCEMENT_PATH,
    loadComponent: () =>
      import('./views/process/options/ceiling-reinforcement/ceiling-reinforcement.component').then(
        (m) => m.CeilingReinforcementComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: OPTIONS_PATH,
    loadComponent: () => import('./views/process/options/options/options.component').then((m) => m.OptionsComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: SCHOOL_INSURANCE_PATH,
    loadComponent: () =>
      import('./views/process/options/school-insurance/school-insurance.component').then(
        (m) => m.SchoolInsuranceComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: DIRECT_DEBIT_PATH,
    loadComponent: () =>
      import('./views/process/options/direct-debit/direct-debit.component').then((m) => m.DirectDebitComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: LESSOR_NOTIFICATION_PATH,
    loadComponent: () =>
      import('./views/process/options/lessor-attestation/lessor-attestation.component').then(
        (m) => m.LessorAttestationComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: INSURER_RESILIATION_PATH,
    loadComponent: () =>
      import('./views/process/options/insurer-resiliation/insurer-resiliation.component').then(
        (m) => m.InsurerResiliationComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: SPECIAL_CONDITIONS_PATH,
    loadComponent: () =>
      import('./views/process/options/special-conditions/special-conditions.component').then(
        (m) => m.SpecialConditionsComponent,
      ),
    canActivate: [StepActivationGuard],
  },
  {
    path: CONFIRMATION_PATH,
    loadComponent: () =>
      import('./views/process/options/confirmation/confirmation.component').then((m) => m.ConfirmationComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: CROSS_SELLING_W_PATH,
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then((m) => m.CrossSellingComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: CROSS_SELLING_C_PATH, // Requires to have two different paths to differentiate W and C channels steps
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then((m) => m.CrossSellingComponent),
    canActivate: [StepActivationGuard],
  },
  {
    path: CONTRACT_VALIDATION_PATH,
    providers: [SkeepersService],
    loadComponent: () =>
      import('./views/process/options/contract-validation/contract-validation.component').then(
        (m) => m.ContractValidationComponent,
      ),
    canActivate: [StepActivationGuard],
  },
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'product/HC',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: SUBSCRIPTION_PATH,
        loadComponent: () =>
          import('./views/process/subscription/subscription.component').then((m) => m.SubscriptionComponent),
        resolve: { contextDeclaration: contextDeclarationResolver },
        children: route_mrh,
      },
      {
        path: 'design-system',
        canActivate: [DevGuard],
        loadComponent: () =>
          import('./views/technical/design-system/design-system.component').then((m) => m.DesignSystemComponent),
      },
      {
        path: START_CONTEXT_PRODUCT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent,
      },
      {
        path: START_CONTEXT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent,
      },
      {
        path: CONTEXT_PATH,
        canActivate: [ContextGuard],
        component: RedirectComponent,
      },
      {
        path: PRODUCT_PATH,
        canActivate: [ProductGuard],
        component: RedirectComponent,
      },
      {
        path: SIGNATURE_STATUS_PATH,
        canActivate: [StartGuard],
        component: RedirectComponent,
      },
      {
        path: E_SIGN_MSG_STATUS_PATH,
        component: ESignMsgComponent,
      },
      {
        path: ERROR_404_PATH,
        component: Error404Component,
      },
      {
        path: ERROR_EMAIL_PATH,
        component: ErrorComponent,
        data: {
          title: 'Attention',
          message: 'Une adresse email est nécessaire pour accéder à ce parcours. Merci de la renseigner.',
        },
      },
      {
        path: '**',
        redirectTo: SUBSCRIPTION_PATH + ROOT_PATH + ADDRESS_PATH,
      },
    ],
  },
];
